import { createApp, type App } from 'vue';
import ClueReportDialog from './src/components/ClueReportDialog.vue';
import { i18n } from './src/i18n';
import { loadScript } from '@eureka/utils/load-script';
import { HUBSPOT_IFRAME_URL, getTargetEditionFormConfig } from './src/constants';
import type { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import type { EActivityTriggerType } from '@eureka/services/src/types/activity-type';
import { DeployEnv } from '@patsnap-utils/biz';
import { REGION } from '@eureka/utils/environment';

/**
 * @description 打开线索报告弹窗
 * @param {EurekaPackageType} pkgType - Required 打开线索弹窗需要达到的目标套餐，与CRM建立映射关系的用处
 * @param {string} version - Required 打开线索弹窗的所属业务线，埋点otherParam需要用到
 * @param {EActivityTriggerType} sourceType - Optional 执行时的场景作为来源
 * @param {Record<string, any>} trackParams - Optional 埋点参数
 * @returns {Promise<boolean | undefined>} - 返回一个 Promise 对象，表示操作的完成情况
 */
export const openClueReport = ({
    pkgType,
    version,
    sourceType,
    trackParams,
}: {
    pkgType: EurekaPackageType;
    version: string;
    sourceType?: EActivityTriggerType;
    trackParams?: Record<string, any>;
}) => {
    const isOversea = [DeployEnv.US, DeployEnv.EU].includes(REGION)
    const targetEditionFormConfig = getTargetEditionFormConfig(pkgType);
    // 只有海外才需要hubspot配置
    if (!targetEditionFormConfig && isOversea) {
        throw new Error(`[openClueReport] edition ${pkgType} is not mapping write in getTargetEditionFormConfig`);
    }
    const option = {
        packageType: pkgType,
        ...targetEditionFormConfig,
        sourceType,
        version,
        trackParams,
    }
    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    div.style.zIndex = '10000';
    div.style.position = 'relative';
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(ClueReportDialog, {
            ...option,
            callback: () => {
                resolve(true);
                unmountApp(app);
            },
            onClose: () => {
                resolve(true);
                unmountApp(app);
                option?.onClose?.();
            },
        });
        app.use(i18n);
        app.mount(div);
        // @ts-ignore
        if (!window.hbspt) {
            loadScript(HUBSPOT_IFRAME_URL);
        }
    });

    return promise;
}
